module.exports = __webpack_public_path__ + "static/img/17.541a7c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/17.jpg
// module id = aJNc
// module chunks = 1